import * as React from 'react';

import {colors} from '../../colors/colors';
import {StackLegacy} from '../../layout/stack/stack-legacy';
import {Body} from '../../typography/body';

import styles from './list.module.css';

type Props = {
    title: string;
    subtitle?: string;
    rightText?: string | React.ReactNode;
    borderColor?: string;
};

export function ListHeader(props: Props) {
    const {borderColor = colors.offWhiteDk} = props;

    return (
        <div style={{borderColor}} className={styles.header}>
            <StackLegacy spacing={2}>
                <Body isBold={true}>{props.title}</Body>
                {props.subtitle && (
                    <Body color='light' size='small'>
                        {props.subtitle}
                    </Body>
                )}
            </StackLegacy>
            {props.rightText && (
                <Body isItalic={true} color='light' size='small'>
                    {props.rightText}
                </Body>
            )}
        </div>
    );
}
